import { withFormsy } from 'formsy-react';
import React from 'react';

class Input extends React.Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const showRequired = this.props.showRequired();

    const {
      showErrors = false,
      label = null,
      required = false,
      name
    } = this.props;

    const hasError = showErrors && errorMessage;

    return (
      <div className="pt-form-group">
        {label && (
          <label className="pt-label" htmlFor={name}>
            {label + " "}
            {required && (
              <span className="f5 pt-text-muted">(required)</span>
            )}
          </label>
        )}
        <div className={"pt-form-content" + (hasError ? " pt-intent-danger" : "")}>
          <div className={"pt-input-group " + (hasError ? " pt-intent-danger" : "")}>
            <textarea id={name}
                      className="pt-input"
                      onChange={this.changeValue}
                      value={this.props.getValue() || ''}>
            </textarea>
          </div>
          <div className="pt-form-helper-text">
            <div className="inline-error">
              {(showErrors && errorMessage) ? (errorMessage) :
               (showErrors && showRequired) ? "Field is required." : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withFormsy(Input);


// WEBPACK FOOTER //
// ./src/components/form/Textarea.js